export {
  getProjectionModel,
  createProjectionSnapshot,
  featureIdsForInput,
  projectFertilityOutcomes,
  PROJECTION_CONTRACT_VERSION,
  PROJECTION_MODEL_ID,
  PROJECTION_MODEL_VERSION,
  PROJECTION_MODELS,
  REFERENCE_EVIDENCE,
  REFERENCE_MODEL,
  REFERENCE_MODEL_METADATA,
  registerProjectionModel,
  selectProjectionModel,
} from "./model";

export {
  GENERAL_EMBRYO_TRANSFER_MODEL,
  GENERAL_EMBRYO_TRANSFER_MODEL_METADATA,
  GENERAL_OOCYTE_OUTCOME_MODEL,
  GENERAL_OOCYTE_OUTCOME_MODEL_METADATA,
  GENERAL_SEMEN_CRYOSURVIVAL_MODEL,
  GENERAL_SEMEN_CRYOSURVIVAL_MODEL_METADATA,
  PLANNED_OC_OUTCOME_MODEL,
  PLANNED_OC_OUTCOME_MODEL_METADATA,
  RETRIEVAL_MODEL,
  RETRIEVAL_MODEL_METADATA,
} from "./adapters";

export { CLINIC_SUCCESS_MODEL, CLINIC_SUCCESS_MODEL_METADATA } from "./clinic";
export { CLINIC_PROJECTION_EVIDENCE } from "./evidence";

export {
  CUMULATIVE_PLANNING_MODEL,
  CUMULATIVE_PLANNING_MODEL_METADATA,
} from "./planning";

export {
  createFertilityPredictionSnapshot,
  DEFAULT_PROJECTION_GOAL,
  projectFertilityPrediction,
} from "./orchestrator";

export {
  doyleAgeRange,
  doyleLiveBirthEstimate,
  DOYLE_SOURCE_ID,
} from "./doyle";
export type { DoyleAgeBand, DoyleLiveBirthEstimate } from "./doyle";

export type {
  EggFreezingCycleInput,
  ClinicProjectionDetails,
  ClinicAgeBand,
  ClinicOutcomeMetric,
  ClinicRateObservation,
  ClinicDonorRateSet,
  ClinicEmbryoSource,
  ClinicPatientModifiers,
  ClinicRateTable,
  ClinicRatePopulation,
  ClinicSingleRate,
  ClinicTreatmentSuccessInput,
  ClinicTreatmentType,
  CumulativeFertilityPlanningInput,
  EmbryoInventoryInput,
  FertilityPredictionResult,
  FertilityPredictionSnapshot,
  FertilityProjectionResult,
  FertilityProjectionSnapshot,
  ObservedValue,
  ObservedFunnelInput,
  ObservedFunnelStageInput,
  OocyteCohortInput,
  PatientProjectionContext,
  ProjectionChange,
  ProjectionAdjustment,
  ProjectionAdjustmentDirection,
  ProjectionEvidenceSource,
  ProjectionEstimate,
  ProjectionEvidenceRole,
  ProjectionEvidenceUsage,
  ProjectionEvidenceUsageStatus,
  ProjectionFeatureId,
  ProjectionGoal,
  ProjectionInput,
  ProjectionKind,
  ProjectionModelMetadata,
  ProjectionModelTrace,
  ProjectionPresentation,
  ProjectionRateSet,
  ProjectionStage,
  ProjectionStageId,
  ProjectionStageBasis,
  ProjectionStatus,
  ProjectionTargetBasis,
  ProjectionTargetResult,
  ProjectionTreatmentContext,
  ProjectionUncertainty,
  PlanningInventoryUnit,
  PlanningModality,
  Provenance,
  ProvenanceSourceType,
  ProvenanceVerificationStatus,
  RateEstimate,
  SemenSampleInput,
  SemenInventoryInput,
  RetrievalOutcomeInput,
  RetrievalComparisonEvidence,
} from "./types";

export type { ProjectionModel } from "./model";
